var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.196566 6.8215C0.133653 6.76441 0.0837253 6.69653 0.0496558 6.62176C0.0155863 6.54699 -0.00195312 6.46681 -0.00195312 6.38583C-0.00195312 6.30485 0.0155863 6.22467 0.0496558 6.14991C0.0837253 6.07514 0.133653 6.00726 0.196566 5.95017L6.52007 0.177649C6.64685 0.0624533 6.81844 -0.00221101 6.99732 -0.00221101C7.17619 -0.00221101 7.34779 0.0624534 7.47456 0.177649L13.7981 5.95017C13.9246 6.06572 13.9957 6.22243 13.9957 6.38583C13.9957 6.54924 13.9246 6.70595 13.7981 6.8215C13.6715 6.93704 13.4998 7.00195 13.3208 7.00195C13.1418 7.00195 12.9701 6.93704 12.8436 6.8215L7.54138 1.97148C7.39701 1.84072 7.20188 1.76736 6.99851 1.76736C6.79514 1.76736 6.60001 1.84072 6.45564 1.97148L1.14628 6.8215C1.01966 6.93696 0.84801 7.00181 0.669039 7.00181C0.490067 7.00181 0.318415 6.93696 0.191793 6.8215",
    fill: "#2C2C2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlack);
export default __webpack_public_path__ + "static/media/arrow_up_black.9880edb418a872b15aab546270bf06c0.svg";
export { ForwardRef as ReactComponent };